import React, { useState } from "react";
import { Box, Typography, Switch, CircularProgress } from "@mui/material";

const InvoiceScanCell = ({ params, setSelectedRow, setOpenInvoiceScanModal }) => {
  const [loading, setLoading] = useState(false);
  
  const isEnabled = params.row.is_invoice_scan_enabled === 1;
  
  const handleToggle = (e) => {
    e.stopPropagation();
    setSelectedRow(params.row);
    setOpenInvoiceScanModal(true);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        height: "100%",
        minHeight: "52px",
        cursor: "pointer",
      }}
      onClick={handleToggle}
    >
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <>
          <Switch
            checked={isEnabled}
            disabled={loading}
            size="small"
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "#4caf50",
                "&:hover": {
                  backgroundColor: "rgba(76, 175, 80, 0.08)",
                },
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#4caf50",
              },
            }}
          />
          <Typography
            variant="body2"
            sx={{
              fontSize: "13px",
              fontWeight: 500,
              color: isEnabled ? "#4caf50" : "#9e9e9e",
            }}
          >
            {isEnabled ? "Enabled" : "Disabled"}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default InvoiceScanCell;